export default __webpack_public_path__ + "static/media/blueOceanSystems.a2f90388.png";